const SpecialtyTag = ({ text }) => (
  <span className="px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded-md font-medium">{text}</span>
);

const TagList = ({ items }) => (
  <div className="flex flex-wrap gap-1.5">
    {items.map((s, i) => <SpecialtyTag key={i} text={s} />)}
  </div>
);

export const SupplierCard = ({ item }) => (
  <div className="bg-white rounded-2xl border border-gray-200 hover:border-[#84CC16]/40 p-6 transition-all duration-300 hover:shadow-lg group">
    <div className="flex items-center gap-4 mb-4">
      <div className="w-12 h-12 text-sm rounded-2xl flex items-center justify-center font-extrabold text-white flex-shrink-0 shadow-md" style={{ backgroundColor: item.color }}>
        {item.initials}
      </div>
      <div className="min-w-0">
        <h3 className="text-lg font-bold text-[#0A1628] truncate">{item.name}</h3>
        <p className="text-xs font-semibold text-[#84CC16] uppercase tracking-wide">{item.category}</p>
      </div>
    </div>
    <p className="text-[#64748B] text-sm leading-relaxed mb-4">{item.description}</p>
    <TagList items={item.specialties} />
  </div>
);
